import davocarLogoFooter from '@/images/clients/davocar-logo.jpg'
import type { IPartnerSettings } from '.'

export const Davocar: IPartnerSettings = {
  partner: 'Davocar',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://davopojisteni.cz/test',
    prep: '',
    production: 'https://davopojisteni.cz/prod',
  },
  hosts: [
    'davopojisteni.cz',
    // 'localhost:44470'
  ],
  logo: davocarLogoFooter
}
